import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ChevronRight } from 'lucide-react';
import ContactActionButtons from '../../buttons/ContactActionButtons';
import { productsPrefetchHandlers } from '@/utils/prefetchProductsRoute';
const HeroContent = () => {
  return <div className="text-left">
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-springbok-800 leading-tight mb-3">
        Your Trusted Partner in Agriculture
      </h1>
      <p className="text-base md:text-lg text-gray-700 mb-4 max-w-xl">
        Kooperasie Veevoer Winkel provides quality animal feed, agricultural supplies, and Hardware to support your farming needs. We've got you covered.

      </p>
      <div className="flex flex-wrap gap-3">
        <Link to="/products" {...productsPrefetchHandlers}>
          <Button className="px-3 py-1.5 h-auto rounded-md text-sm" data-gradient="green">
            Shop Now <ChevronRight size={14} className="ml-1" />
          </Button>
        </Link>
      </div>
      <div className="mt-5">
        <ContactActionButtons />
      </div>
    </div>;
};
export default HeroContent;